import { useTranslation } from 'react-i18next';
import { pageStyles, cardStyles, formStyles } from '../../lib/styles';
import { useAuth } from '../../contexts/AuthContext';

export function ProfilePage() {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'admin':
        return t('staff.roles.admin');
      case 'reception':
        return t('staff.roles.reception');
      case 'workshop':
        return t('staff.roles.workshop');
      default:
        return role;
    }
  };

  return (
    <div className={pageStyles.container}>
      <div className={cardStyles.container}>
        <div className={cardStyles.header}>
          <span className="text-xs font-medium text-gray-900">{t('settings.profile')}</span>
        </div>
        <div className={cardStyles.content}>
          <p className="text-xs text-gray-500">
            {t('settings.emailReadOnly')}
          </p>

          <div className="mt-4 grid gap-4 sm:grid-cols-2">
            <div className="space-y-1">
              <label className={formStyles.label}>{t('staff.name')}</label>
              <div className="rounded-md border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-xs text-gray-900">
                {user.name}
              </div>
            </div>

            <div className="space-y-1">
              <label className={formStyles.label}>{t('staff.email')}</label>
              <div className="rounded-md border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-xs text-gray-500">
                {user.email}
              </div>
            </div>

            <div className="space-y-1">
              <label className={formStyles.label}>{t('staff.role')}</label>
              <div className="rounded-md border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-xs text-gray-500">
                {getRoleLabel(user.role)}
              </div>
              <p className="text-[11px] text-gray-400">{t('settings.roleReadOnly')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
